import React from "react";
import Joi from "joi-browser";
import Form from "./../common/form";
import * as authService from "../../services/auth";
import withSnackbarWrapper from "../common/withSnackbarWrapper";
import PrivacyPolicy from "./../common/privacyPolicy";
import TermsOfService from "./../common/termsOfServices";
import { Link } from "react-router-dom";

class Register extends Form {
  state = {
    data: {
      email: "",
      password: "",
      name: "",
      confirmPassword: "",
      checkToS: false,
    },
    errors: {},
    showToSModal: false,
    showPrivacyModal: false,
  };

  schema = {
    email: Joi.string().required().label("Email"),
    password: Joi.string().label("Password"),
    name: Joi.string().required().label("Full Name"),
    confirmPassword: Joi.string().required().label("Confirm Password"),
  };

  doSubmit = () => {
    const error = this.validateRegisterForm(this.state.data);

    if (error) return this.props.enqueueSnackbar(error, "warning");

    authService
      .register(this.state.data)
      .then((response) => {
        if (response.success) {
          this.props.enqueueSnackbar(response.message, "success");
          let self = this;
          setTimeout(() => {
            const { state } = self.props.location;
            window.location = state ? state.from.pathname : "/login";
          }, 2000);
        } else {
          this.props.enqueueSnackbar(response.message, "warning");
        }
      })
      .catch((err) => {
        console.log("Some error occured.", err);
      });
  };

  validateRegisterForm = (data) => {
    let error = "";
    if (data.password !== data.confirmPassword)
      error = "Passwords do not match.";
    else if (data.password.length < 5)
      error = "Passwords length should be greater than 5.";
    return error;
  };

  showToSModal = (event) => {
    event.preventDefault();
    this.setState({ showToSModal: true });
  };

  hideToSModal = () => {
    this.setState({ showToSModal: false });
  };

  showPrivacyModal = (event) => {
    event.preventDefault();
    this.setState({ showPrivacyModal: true });
  };

  hidePrivacyModal = () => {
    this.setState({ showPrivacyModal: false });
  };

  render() {
    const { showToSModal, showPrivacyModal } = this.state;

    return (
      <div className="container mt-5">
        <h1>Create your Vocal Results Studio Account </h1>
        <form onSubmit={this.handleSubmit} className="mt-5 register-form">
          {this.renderInput("name", "Full Name", "text", {
            autoComplete: "off",
          })}
          {this.renderInput("email", "Email", "email", {
            autoComplete: "off",
          })}
          {this.renderInput("password", "Password", "password", {
            autoComplete: "off",
          })}
          {this.renderInput("confirmPassword", "Confirm Password", "password", {
            autoComplete: "off",
          })}
          <div className="form-group">
            <div className="form-check d-flex">
              <input
                className="form-check-input"
                type="checkbox"
                value=""
                id="terms"
                required
                name="terms"
              />
              <label className="form-check-label" htmlFor="terms">
                I agree to the{" "}
                <span onClick={this.showToSModal}>Terms of Service</span> and{" "}
                <span onClick={this.showPrivacyModal}>Privacy Policy</span>
              </label>
              <span className="form-other-redirect">
                Already a Member? Login <Link to="/login">here</Link>
              </span>
            </div>
          </div>
          {this.renderButton("Sign up")}
        </form>

        {showToSModal && (
          <TermsOfService show={showToSModal} hideToS={this.hideToSModal} />
        )}

        {showPrivacyModal && (
          <PrivacyPolicy
            show={showPrivacyModal}
            hidePrivacyModal={this.hidePrivacyModal}
          />
        )}
      </div>
    );
  }
}

export default withSnackbarWrapper(Register);
